import { render, staticRenderFns } from "./Hangar.vue?vue&type=template&id=8ae3fd54&scoped=true&"
import script from "./Hangar.vue?vue&type=script&lang=js&"
export * from "./Hangar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae3fd54",
  null
  
)

export default component.exports